<template>
  <div class="product-wrapper">
    <div class="product">
      <div class="image" :style="[product.marketing_image !== null ? {'background-image': 'url(' + product.marketing_image + ')'} : '']" @click="goTo(product.url)"></div>
      <div class="content">
        <h3 class="no-underline">Maintenance Parts for <span data-localizer="ignore">{{ product.sku }}</span></h3>
      </div>
      <div class="buttons">
        <a :href="product.url" title="More Detail" class="btn-red">More Detail</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePartsCard',
  props: {
    product: Object
  },
  methods: {
    goTo: function (url) {
      document.location = url
    }
  }
}
</script>
